import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { images } from '../../shared/assets';
import { PageToggleButton } from '../../shared/PageToggleButton';
import { CTALink } from '../../shared/CTALink/CTALink';
import './CarbonNeutralSection.css';

interface CarbonNeutralContent {
  title: string;
  description: string;
  image: string;
  learnMoreUrl: string;
}

// Move pages array inside component to use translations
const useCarbonNeutralPages = () => {
  const { t } = useTranslation();
  
  return [
    {
      title: t('pages/home:carbon.content.conservation.title'),
      description: t('pages/home:carbon.content.conservation.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    },
    {
      title: t('pages/home:carbon.content.wildlife.title'),
      description: t('pages/home:carbon.content.wildlife.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    },
    {
      title: t('pages/home:carbon.content.sustainability.title'),
      description: t('pages/home:carbon.content.sustainability.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    },
    {
      title: t('pages/home:carbon.content.unGoals.title'),
      description: t('pages/home:carbon.content.unGoals.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    },
    {
      title: t('pages/home:carbon.content.santaCatarinaPractices.title'),
      description: t('pages/home:carbon.content.santaCatarinaPractices.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    },
    {
      title: t('pages/home:carbon.content.beeRoute.title'),
      description: t('pages/home:carbon.content.beeRoute.description'),
      image: images.destinationsCarbonNeutralBg,
      learnMoreUrl: "/producing-nature"
    }
  ];
};

export const CarbonNeutralSection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const carbonNeutralPages = useCarbonNeutralPages();
  const [activePage, setActivePage] = useState(0);
  const currentContent = carbonNeutralPages[activePage];

  const handlePageToggle = (pageIndex: number) => {
    setActivePage(pageIndex);
  };

  return (
    <section className="carbon-neutral-section">
      <div className="carbon-neutral-section__container">
        <div className="carbon-neutral-section__headline">
          <p>{t('pages/home:carbon.headline')}</p>
        </div>
        <img
          src={currentContent.image}
          alt={t('pages/home:carbon.imageAlt')}
          className="carbon-neutral-section__image"
        />
        <div className="carbon-neutral-section__content-box">
          <div className="carbon-neutral-section__content-box-bg" />
          <div className="carbon-neutral-section__content">
            <div className="carbon-neutral-section__text-group">
              <h3 className="carbon-neutral-section__title">
                {currentContent.title}
              </h3>
              <p className="carbon-neutral-section__description">
                {currentContent.description}
              </p>
            </div>
            <CTALink 
              text="READ MORE"
              type="secondary"
              color="off-white"
              onClick={() => navigate(currentContent.learnMoreUrl)}
              className="carbon-neutral-section__link"
            />
          </div>
          <div className="carbon-neutral-section__page-toggles">
            {carbonNeutralPages.map((_, index) => (
              <PageToggleButton
                key={index}
                number={index + 1}
                isActive={activePage === index}
                onClick={() => handlePageToggle(index)}
                color="off-white"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};